// @ts-nocheck

import * as Yup from 'yup'
import { messageHelper } from '../../utils/messageHelper'

export const locationSchema = Yup.object().shape({
  city: Yup.string().required(messageHelper.yup.error.cityIsMandatory),
  state: Yup.string().required(messageHelper.yup.error.stateIsMandatory)
})
